<template>
  <div class="salaries-header">
    <div class="salaries-header__back">
      <img
        loading="lazy"
        class="salaries-header__back-img-mobile"
        src="./images/bg-pins-mobile.png"
        srcset="./images/bg-pins-mobile.png, ./images/bg-pins-mobile@2x.png 2x"
        alt=""
      />
      <img
        loading="lazy"
        class="salaries-header__back-img-desktop"
        src="./images/bg-pins-desktop.png"
        srcset="./images/bg-pins-desktop.png, ./images/bg-pins-desktop@2x.png 2x"
        alt=""
      />
    </div>
    <div class="salaries-header__wrapper">
      <BravadoText class="salaries-header__header" tag="h1" variant="header1">
        2022 Bravado State of Sales Compensation Guide
      </BravadoText>
      <BravadoText class="salaries-header__headline" tag="p" variant="headline">
        Salespeople are getting paid more than ever, but the industry has also never been more volatile. Read below to
        see how the sales landscape is changing in 2022.
      </BravadoText>

      <BravadoText class="salaries-header__methodology" tag="h2" variant="header3">Methodology</BravadoText>
      <BravadoText class="salaries-header__methodology-headline" tag="p" variant="headline">
        The State of Sales Compensation presented in this guide has been collected from Bravado's network, comprised of
        150,000+ individual Sales Professionals from over 11,000 different companies and 82 countries around the world.
      </BravadoText>
    </div>

    <template v-for="{ id, zoom, blur, top, left, val } in tooltips">
      <SalariesTooltip :key="id" :top="top" :left="left" :blur="blur" :zoom="zoom">${{ val }}k</SalariesTooltip>
    </template>

    <img loading="lazy" src="./images/shadow_top.png" alt="map" class="salaries-header__shadow-top" />

    <img loading="lazy" src="./images/shadow.png" alt="map" class="salaries-header__shadow" />

    <img loading="lazy" src="./images/map.png" alt="map" class="salaries-header__map" />
  </div>
</template>

<script>
import SalariesTooltip from './SalariesTooltip';
import BravadoText from '~/components/common/BravadoText/BravadoText.vue';

export default {
  name: 'SalariesHeader',
  components: { BravadoText, SalariesTooltip },
  computed: {
    tooltips() {
      return [];
    },
  },
};
</script>
<style lang="scss" scoped>
.salaries-header {
  background: #161a21;
  height: 1414px;
  width: 100%;
  position: relative;

  &__back {
    position: absolute;
    left: 0;
    right: 0;
  }

  &__back-img-desktop {
    display: none;
    width: 100%;
    height: auto;

    @include mq('sm') {
      display: block;
    }
  }

  &__back-img-mobile {
    display: block;
    width: 100%;
    height: auto;

    @include mq('sm') {
      display: none;
    }
  }

  &__wrapper {
    margin: 0 auto;
    max-width: 1000px;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    z-index: 3;
  }

  &__header {
    color: #fff;
    margin-top: 130px;
    text-align: center;
    padding: 0 15px;
  }

  &__headline {
    font-size: 20px;
    margin-top: 20px;
    line-height: 1.5;
    color: #afb7bf;
    text-align: center;
    padding: 0 50px;

    @include mq('sm') {
      padding: 0 100px;
    }
  }

  &__methodology {
    margin-bottom: 16px;
    padding: 170px 25px 0 25px;
    color: #fff;

    @include mq('1700px') {
      padding: 25px 25px 0 25px;
    }
  }

  &__methodology-headline {
    padding: 0 25px;
    width: 400px;
    color: #afb7bf;
  }

  &__map {
    position: absolute;
    left: 0;
    bottom: 100px;
    width: 200%;
    margin-left: -20%;
    z-index: 2;

    @include mq('sm') {
      margin-left: 0;
      width: 100%;
    }
  }

  &__shadow {
    position: absolute;
    left: 0;
    bottom: 0;
    z-index: 1;
  }

  &__shadow-top {
    position: absolute;
    right: 0;
    top: 0;
    z-index: 1;
  }
}
</style>
